import { QueryObserverBaseResult, useQuery } from "react-query";
import { queryKeys } from "../../query";
import api from "../../client";
import { PlacementEnvironmentTemplateDetailResponseData } from "../../types/placement-environment-template";

export const getData = async (
  id: string | undefined,
): Promise<PlacementEnvironmentTemplateDetailResponseData> => {
  const { data } = await api.get(`/placement-environment-templates/${id}`);

  return data;
};

export const usePlacementEnvironmentTemplate = (
  id: string | undefined,
): QueryObserverBaseResult<PlacementEnvironmentTemplateDetailResponseData> => {
  const { data, ...props } = useQuery(
    queryKeys.placementEnvironmentTemplate(id),
    () => getData(id),
    { enabled: Boolean(id) },
  );
  return { data, ...props };
};
